export default __webpack_public_path__ + "static/media/1257.6b6804ed.png";